const Field = ({ label, children }) => {
  return (
    /*  <div className="dx-field">
      <div className="dx-field-label">{label}</div>
      <div className="dx-field-value">{children}</div>
    </div> */

    <tr>
      <td className="py-2 text-sm font-bold pr-4 ">{label}</td>
      <td className="py-2 pr-4">&nbsp;</td>
      <td className="py-2 ">{children}</td>
    </tr>
  );
};

export default Field;
